let html2Escape = (strText) => {
	if(!strText){
		return ''
	}
	return strText.replace(/[<>&"]/g, function (c) {
		return {
			'<': '&lt;',
			'>': '&gt;',
			'&': '&amp;',
			'"': '&quot;'
		}[c];
	});
}

// 文本消息禁止中文字符，覆盖常用汉字及扩展区。
const chinesePattern = /[\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF]/;
const chinesePatternGlobal = new RegExp(chinesePattern.source, 'g');

let containsChinese = (value) => {
	return typeof value === 'string' && chinesePattern.test(value);
}

let stripChinese = (value) => {
	return typeof value === 'string' ? value.replace(chinesePatternGlobal, '') : value;
}

export default {
	html2Escape,
	containsChinese,
	stripChinese
}
